import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StandardLayout } from "@/components/layouts";

import {
    WaitingForBrokerImage,
    WaitingForBrokerMessage,
    WaitingForBrokerTitle,
    WaitingForBrokerWrapper,
} from "./styled";

const WaitingForBroker: FC = () => {
    const { t } = useTranslation();

    return (
        <StandardLayout>
            <WaitingForBrokerWrapper>
                <WaitingForBrokerImage />
                <WaitingForBrokerTitle>{t("WaitingForBroker.WaitingConfirmation")}</WaitingForBrokerTitle>
                <WaitingForBrokerMessage>{t("WaitingForBroker.WaitingMessage")}</WaitingForBrokerMessage>
            </WaitingForBrokerWrapper>
        </StandardLayout>
    );
};
export default WaitingForBroker;
